import React, { useState } from 'react'
import { DropDown } from '../../../commons'
import { countryCode } from '../../../../constant/countryCode';
import { InputDetailsErrorType } from '..';
import { isEmailValid } from '../../../../utils/commonFunctions';
const selectStyle = {
    option: (baseStyles: any, state: any) => ({
        ...baseStyles,

        whiteSpace: "wrap",
    }),
    control: (provided: any, state: any) => ({
        ...provided,
        width: "80px",
        fontSize: "14px",
        borderTopRightRadius: "0px",
        borderBottomRightRadius: "0px",
        borderRight: "0px",
        "&:hover": { borderColor: "none" },
        border: "1px solid rgba(0, 0, 0, 0.125)",
        boxShadow: "none", // no box-shadow
    }),
    container: (provided: any) => ({
        ...provided,
        width: 365,
        position: "absolute",
    }),
    indicatorSeparator: (provided: any, state: any) => ({
        ...provided,
        padding: "0px",
        display: "none",
    }),
    dropdownIndicator: (provided: any, state: any) => ({
        ...provided,
        padding: "0px",
    }),
    myDropDown__indicator: (base: any) => ({
        ...base,
        "&.myDropDown__dropdown-indicator": {
            "&.indicatorContainer": {
                color: "#000000",
                padding: "1px",
            },
        },
    }),
};
type AppProps = {
    communication: any;
    setClientBasicDetails: (data: any) => void;
    inputDetailsError: InputDetailsErrorType;
    setInputDetailsError: (data: any) => void;
    isDisabled?:boolean
}
const Communications = ({
    communication,
    setClientBasicDetails,
    inputDetailsError,
    setInputDetailsError,
    isDisabled
}: AppProps) => {
    const [mobileNumber, setmobileNumber] = useState({
        label: "+91",
        value: "+91",
    });
    const [whatsAppNumber, setWhatsAppNumber] = useState({
        label: "+91",
        value: "+91",
    });
    const option: any = countryCode?.map((e) => {
        return {
            label: `${e.flag} ${e.name}(${e.dial_code})`,
            value: e.dial_code,
        };
    });

    const handleMobileNumber = (data: any) => {
        // setMobileCountryCode(data?.value);

        setmobileNumber({
            label: data?.value,
            value: data?.value,
        });
    };
    const handleWhatsappMobileNumber = (data: any) => {
        // setWhatsappCountryCode(data?.value);

        setWhatsAppNumber({
            label: data?.value,
            value: data?.value,
        });
    };

    const handleCommunicationDetailsChange = (data: any) => {
        
        if (data.target.name === "mobile") {
            if (data.target.value) {
                setInputDetailsError((prev: any) => {
                    return {
                        ...prev,
                        mobileError: ""
                    }
                })
            }
        }
        if (data.target.name === "email") {
            if (data.target.value) {
                const emailValidation = !isEmailValid(data.target.value)
                if (emailValidation&&data.target.value?.length) {
                    setInputDetailsError((prev: any) => {
                        return {
                            ...prev,
                            emailError: "Email not valid"
                        }
                    })
                }
                else {
                    setInputDetailsError((prev: any) => {
                        return {
                            ...prev,
                            emailError: ""
                        }
                    })
                }
            }
            else {
                setInputDetailsError((prev: any) => {
                    return {
                        ...prev,
                        emailError: ""
                    }
                })
            }
        }
        setClientBasicDetails((prev: any) => {
            return {
                ...prev,
                communication: {
                    ...prev.communication,
                    [data.target.name]: data.target.value
                }
            }
        })
    }
    return (
        <>
            <div className="row">
                <div className="col-md-3">
                    <label htmlFor="workPhone">Work Phone</label>

                    <div style={{ display: "flex", gap: "2px", position: "relative" }}>
                        <DropDown
                            options={option}
                            value={mobileNumber}
                            handleChange={handleMobileNumber}
                            disabled
                            style={selectStyle}
                        />
                        <input
                            type="number"
                            className="form-control dropDown-input"
                            name="workPhone"
                            style={{
                                borderTopLeftRadius: '00px',
                                borderBottomLeftRadius: '0px',
                            }}
                            onChange={handleCommunicationDetailsChange}
                            value={communication?.workPhone}
                            disabled={isDisabled}
                        // onWheel={event => event.currentTarget.blur()}
                        />
                    </div>
                </div>
                <div className="col-md-3">
                    <label htmlFor="mobile">Mobile<span className='color-red'>*</span></label>
                    <div className={`${inputDetailsError?.mobileError ? "error-border rounded" : ""}`} style={{ display: "flex", gap: "2px" }}>
                        <DropDown
                            options={option}
                            value={whatsAppNumber}
                            handleChange={handleWhatsappMobileNumber}
                            disabled
                            style={selectStyle}
                        />
                        <input
                            type="number"
                            className={`form-control dropDown-input`}
                            style={{
                                borderTopLeftRadius: '00px',
                                borderBottomLeftRadius: '0px',
                            }}
                            name="mobile"
                            onChange={handleCommunicationDetailsChange}
                            value={communication?.mobile}
                            disabled={isDisabled}
                        // onWheel={event => event.currentTarget.blur()}
                        />
                    </div>
                    {!!inputDetailsError?.mobileError && (
                        <small className="text-danger">{inputDetailsError?.mobileError}</small>
                    )}
                </div>
                <div className="col-md-3">
                    <label htmlFor="fax">Fax</label>
                    <input
                        type="text"
                        className="form-control"
                        name="fax"
                        onChange={handleCommunicationDetailsChange}
                        value={communication?.fax}
                        disabled={isDisabled}
                    />
                </div>
                <div className="col-md-3">
                    <label htmlFor="homePhone">Home Phone</label>
                    <input
                        type="number"
                        className="form-control"
                        name="homePhone"
                        onChange={handleCommunicationDetailsChange}
                        value={communication?.homePhone}
                        disabled={isDisabled}
                    // onWheel={event => event.currentTarget.blur()}
                    />
                </div>
            </div>
            <div className='row'>
                <div className="col-md-3 mt-3">
                    <label htmlFor="email">Email<span className='color-red'>*</span></label>
                    <input
                        type="email"
                        className={`form-control ${inputDetailsError?.emailError ? "error-border" : ""}`}
                        name="email"
                        onChange={handleCommunicationDetailsChange}
                        value={communication?.email}
                        disabled={isDisabled}
                    />
                    {!!inputDetailsError?.emailError && (
                        <small className="text-danger">{inputDetailsError?.emailError}</small>
                    )}
                </div>
            </div>
        </>
    )
}

export default Communications